var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{ref:"icon",staticClass:"glyph",style:('font-size: ' + _vm.fontSize + 'px; color: ' + _vm.color + ';')},[_vm._v(_vm._s(_vm.icon))])])
}
var staticRenderFns = []

export { render, staticRenderFns }